<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage" id="dedicationpage">
<a id="page05">
<p class="dedicationText" style="text-indent: 0%;">To every client, every audience member,<br/> everyone who’s ever read my books,<br/> everyone who’s ever touched my life along the way—<br/>you’ve contributed more to this book<br/> and to the journey of my soul<br/> than I can ever repay.</p>
</a></div>
<a id="page05">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003dedicationpage.vue?cec01eea